import { render, staticRenderFns } from "./grid-six.vue?vue&type=template&id=814d52ea&"
import script from "./grid-six.vue?vue&type=script&lang=js&"
export * from "./grid-six.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('814d52ea')) {
      api.createRecord('814d52ea', component.options)
    } else {
      api.reload('814d52ea', component.options)
    }
    module.hot.accept("./grid-six.vue?vue&type=template&id=814d52ea&", function () {
      api.rerender('814d52ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/grid-six.vue"
export default component.exports